// ------------------ Split ------------------ //

function runSplit() {
  text = new SplitType("[animation=loading-split]", {
    types: "lines",
    lineClass: "line-animation-split",
  });
  textfade = new SplitType("[animation=fade-split]", {
    types: "lines, chars",
    lineClass: "line-split-fade",
    charClass: "char-split-fade",
  });
  textheading = new SplitType("[animation=load--heading]", {
    types: "lines",
    lineClass: "animation-heading-split",
  });

  textquotes = new SplitType("[animation=quote-fade]", {
    types: "words",
    wordClass: "quote-fade-split",
  });
}

runSplit();

// Update on window resize
let windowWidth = $(window).innerWidth();
window.addEventListener("resize", function () {
  if (windowWidth !== $(window).innerWidth()) {
    windowWidth = $(window).innerWidth();
    text.revert();
    textfade.revert();
    textheading.revert();
    textquotes.revert();
    runSplit();
  }
});

// ------------------ gsap ------------------ //

gsap.registerPlugin(ScrollTrigger, CustomEase);

// ------------------ smooth scrolling ------------------ /

let smoother;

function initializeScrollSmoother() {
  if (!smoother) {
    gsap.registerPlugin(ScrollSmoother);

    // Check if the screen width is below 991px
    const shouldEnableEffects = window.innerWidth >= 991;

    smoother = ScrollSmoother.create({
      smooth: 1,
      effects: shouldEnableEffects, // Enable or disable based on screen width
    });
  }
}

function updateOnResize() {
  // Check if smoother instance exists
  if (smoother) {
    // Update the effects property based on the current window width
    smoother.effects(window.innerWidth >= 991);

    // Update the smoother instance
    if (smoother.update) {
      smoother.update();
    }
  }
}

// Debounce function
function debounce(func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
}

// Initialize ScrollSmoother on DOMContentLoaded
document.addEventListener("DOMContentLoaded", initializeScrollSmoother);

// Add debounced resize event listener
window.addEventListener("resize", debounce(updateOnResize, 250));

// ------------------ smooth ease ------------------ //

CustomEase.create("smooth", "M0,0 C0.38,0.005 0.215,1 1,1");

// ------------------ loading screen ------------------ //

function pageLoad() {
  let tl = gsap.timeline();

  tl.to(".main-wrapper", {
    opacity: 1,
    ease: "smooth",
    duration: 0.6,
  });

  // Add a label to mark the starting point of simultaneous animations
  tl.add("loadingAnimationsStart");

  // Add the 'loading' animation and set its position to the label
  tl.from(
    ".line-animation-split",
    {
      y: "100%",
      opacity: "0",
      stagger: { each: 0.02, from: "start" },
      ease: "smooth",
      duration: 0.6,
    },
    "loadingAnimationsStart"
  );
  tl.from(
    "[animation=loading]",
    {
      y: "20rem",
      opacity: "0",
      stagger: { each: 0.1, from: "start" },
      ease: "smooth",
      duration: 0.6,
    },
    "loadingAnimationsStart"
  ); // <-- position parameter set to the label
}

pageLoad();

// ------------------ scroll trigger ------------------ //
document.querySelectorAll(".line-split-fade").forEach(function (fadeSplitElem) {
  gsap.from(fadeSplitElem.querySelectorAll(".char-split-fade"), {
    scrollTrigger: {
      trigger: fadeSplitElem,
      start: "bottom bottom",
      markers: false,
    },
    y: "-100%",
    ease: "smooth",
    duration: 0.6,
    stagger: {
      each: 0.05,
    },
  });
});

document.querySelectorAll("[animation=fade]").forEach(function (fadeSplitElem) {
  gsap.from(fadeSplitElem, {
    scrollTrigger: {
      trigger: fadeSplitElem,
      start: "top bottom",
      markers: false,
    },
    y: "20rem",
    opacity: 0,
    ease: "smooth",
    duration: 0.6,
    delay: 0.2,
  });
});

document
  .querySelectorAll("[animation=fade-stagger]")
  .forEach(function (fadeSplitElem) {
    gsap.from(fadeSplitElem.querySelectorAll("[animation=fade-item]"), {
      scrollTrigger: {
        trigger: fadeSplitElem,
        start: "top bottom",
        markers: false,
      },
      y: "40rem",
      opacity: 0,
      ease: "smooth",
      delay: 0.2,
      duration: 0.6,
      stagger: {
        each: 0.1,
      },
    });
  });

// ------------------ quote fade ------------------ //
document
  .querySelectorAll("[animation=quote-fade]")
  .forEach(function (fadeSplitElem) {
    gsap.from(fadeSplitElem.querySelectorAll(".quote-fade-split"), {
      scrollTrigger: {
        trigger: fadeSplitElem,
        start: "top center+=100",
        end: "bottom center+=100",
        markers: false,
        scrub: true,
      },
      opacity: "0.1",
      stagger: {
        each: 0.05,
      },
    });
  });

// ------------------ accordion ------------------ //
$(".faq--question").on("click", function () {
  // Close other accordions when opening new one
  if (!$(this).hasClass("open")) {
    $(".faq--question.open").click();
  }
  // Save the sibling of the toggle we clicked on
  let sibling = $(this).siblings(".faq--response");
  let animationDuration = 500;

  if ($(this).hasClass("open")) {
    // Close the content div if already open
    sibling.animate({ height: "0px" }, animationDuration);
  } else {
    // Open the content div if already closed
    sibling.css("height", "auto");
    let autoHeight = sibling.height();
    sibling.css("height", "0px");
    sibling.animate({ height: autoHeight }, animationDuration, () => {
      sibling.css("height", "auto");

      // Scroll the page to the accordion, leaving 200 pixels from the top
    });
  }
  // Open and close the toggle div
  $(this).toggleClass("open");
});

// ------------------ accordion ------------------ //
$(".drop--menu").on("click", function () {
  // Close other accordions when opening new one
  if (!$(this).hasClass("open")) {
    $(".drop--menu.open").click();
  }
  // Save the sibling of the toggle we clicked on
  let sibling = $(this).siblings(".drop--sub-menu");
  let animationDuration = 500;

  // Disable pointer events and adjust opacity during animation
  sibling.css({ pointerEvents: "none", opacity: 1 });

  if ($(this).hasClass("open")) {
    // Close the content div if already open
    sibling.animate({ height: "0px" }, animationDuration, () => {
      sibling.css({ pointerEvents: "none", opacity: 0 });
    });
  } else {
    // Open the content div if already closed
    sibling.css("height", "auto");
    let autoHeight = sibling.height();
    sibling.css("height", "0px");
    sibling.animate({ height: autoHeight }, animationDuration, () => {
      sibling.css({ height: "auto", pointerEvents: "auto", opacity: 1 });

      // Scroll the page to the accordion, leaving 200 pixels from the top
    });
  }
  // Open and close the toggle div
  $(this).toggleClass("open");
});

// --------------------- sticky ---------------------- //

document
  .querySelectorAll("[animation=sticky-trigger]")
  .forEach(function (fadeSplitElem) {
    gsap.to(fadeSplitElem.querySelectorAll("[animation=sticky-item]"), {
      scrollTrigger: {
        trigger: fadeSplitElem,
        start: "top top", // or adjust to when you want it to stick
        end: () =>
          "+=" +
          (fadeSplitElem.clientHeight -
            fadeSplitElem.querySelector("[animation=sticky-item]")
              .clientHeight),

        markers: false,
        pin: true,
        scrub: true,
      },
    });
  });

// ------------------ Navbar ------------------ //

// GSAP Timeline for the menu animation
const menuTimeline = gsap.timeline({ paused: true, reversed: true });

menuTimeline
  .set(".navbar--menu-extand", { display: "flex" }) // Initially set display to flex
  .set(".navbar--menu-icon-close", { y: "20rem", opacity: 0 }) // Initially set display to flex

  .from(
    ".navbar--menu-extand",
    { opacity: 0, ease: "smooth", duration: 0.2 },
    0
  )
  .to(".navbar", { color: "black", ease: "smooth", duration: 0.2 }, 0) // Fade in the menu
  .to(
    ".navbar--menu-icon",
    { y: "-20rem", ease: "smooth", opacity: 0, duration: 0.4 },
    0
  ) // Move and fade out the menu icon
  .to(
    ".navbar--menu-icon-close",
    { y: "0rem", opacity: 1, ease: "smooth", duration: 0.4 },
    0
  ) // Move and fade in the close icon
  .from(
    ".menu--extand",
    { x: "-60vw", scale: 1.1, ease: "smooth", duration: 0.5 },
    0
  ) // Slide in the menu content
  .from(
    ".image--menu-extand",
    { x: "50vw", scale: 1.1, ease: "smooth", duration: 0.5 },
    0
  ); // Slide in the image

// Event listener for the trigger
document
  .querySelector(".navbar--menu-trigger")
  .addEventListener("click", () => {
    menuTimeline.reversed() ? menuTimeline.play() : menuTimeline.reverse();
  });

// navbar color
$(document).ready(function () {
  var scrollTop = 0;
  $(window).scroll(function () {
    scrollTop = $(window).scrollTop();
    if (scrollTop >= 50) {
      $(".navbar").addClass("is--scrolled");
    } else if (scrollTop < 50) {
      $(".navbar").removeClass("is--scrolled");
    }
  });
});

// ------------------ cart toggle ------------------ //

document.addEventListener("DOMContentLoaded", function () {
  // When clicking .card--btn-top -> open the overlay and cart
  document.body.addEventListener("click", function (event) {
    if (event.target.closest(".card--btn-top")) {
      document.querySelector(".slidecarthq-overlay")?.classList.add("open");
      document.querySelector(".slidecarthq.right")?.classList.add("open");
    }
  });

  // When clicking #slidecarthq .header button or .slidecarthq-overlay -> close the overlay and cart
  document.body.addEventListener("click", function (event) {
    if (
      event.target.closest("#slidecarthq .header button") ||
      event.target.classList.contains("slidecarthq-overlay")
    ) {
      document.querySelector(".slidecarthq-overlay")?.classList.remove("open");
      document.querySelector(".slidecarthq.right")?.classList.remove("open");
    }
  });
});

// ------------------ marquee ------------------- //

const scrollSpeed = 50;
function startScrolling(element) {
  const scrollWidth = element.offsetWidth;
  let startTime = null;
  function animate(time) {
    if (!startTime) startTime = time;
    const timeElapsed = time - startTime;
    const scrollPosition = ((timeElapsed * scrollSpeed) / 1000) % scrollWidth;
    element.style.transform = `translateX(${-scrollPosition}px)`;
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);
}
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".is--scrolling").forEach(startScrolling);
});

// ------------------ colors products ------------------- //

window.addEventListener("DOMContentLoaded", (event) => {
  // Select all product slides
  const productSlides = document.querySelectorAll(".product-slide");

  productSlides.forEach((slide, index) => {
    // Get the content of the textcolor and backgroundcolor elements within each slide
    const textColor = slide.querySelector(".textcolor").textContent.trim();
    const backgroundColor = slide
      .querySelector(".backgroundcolor")
      .textContent.trim();

    // Generate the dynamic styles with unique classes based on the index
    const styles = `
          .product-slide-${index} {
              color: ${textColor};
              background-color: ${backgroundColor};
          }
      `;

    // Create a unique class for each product slide
    slide.classList.add(`product-slide-${index}`);

    // Apply the styles to the <style> element
    document.getElementById("dynamic-styles").textContent += styles;
  });
});

// ------------------ video background change ------------------- //

document.addEventListener("DOMContentLoaded", function () {
  const mediaQuery = window.matchMedia("(max-width: 992px)");

  // Function to update video source based on screen size
  function updateVideoSource() {
    // Get all elements with class 'video--link-hero' and 'video--link-hero-mobile'
    const videoLinks = document.querySelectorAll(".video--link-hero");
    const videoLinksMobile = document.querySelectorAll(
      ".video--link-hero-mobile"
    );

    videoLinks.forEach((videoLink, index) => {
      // Determine which link to use based on screen size
      const videoContainer = videoLink.previousElementSibling;

      if (videoContainer) {
        const sourceElement = videoContainer.querySelector("source");

        if (sourceElement) {
          const isMobile = mediaQuery.matches;
          const videoLinkMobile = videoLinksMobile[index];
          const selectedSource =
            isMobile && videoLinkMobile
              ? videoLinkMobile.textContent.trim()
              : videoLink.textContent.trim();

          // Update the src of the source element
          sourceElement.src = selectedSource;
          // Reload the video element to apply the new source
          videoContainer.querySelector("video").load();
        }
      }
    });
  }

  // Run on page load
  updateVideoSource();

  // Add an event listener to detect screen size changes
  mediaQuery.addEventListener("change", updateVideoSource);
});

// ------------------ swiper feeatured products ------------------------- //

$(".is--home-featured-slider").append(`
    <div class="swiper--btns"><a href="#" class="swiper-button-prev w-inline-block swiper-button-disabled" tabindex="-1" role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-f613da331297fa67" aria-disabled="true"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 48 48" fill="none"><path d="M13.2675 22.9892C12.877 23.3797 12.877 24.0129 13.2675 24.4034L19.6315 30.7674C20.022 31.1579 20.6552 31.1579 21.0457 30.7674C21.4362 30.3768 21.4362 29.7437 21.0457 29.3531L15.3889 23.6963L21.0457 18.0394C21.4362 17.6489 21.4362 17.0157 21.0457 16.6252C20.6552 16.2347 20.022 16.2347 19.6315 16.6252L13.2675 22.9892ZM33.4177 22.6963L13.9746 22.6963L13.9746 24.6963L33.4177 24.6963L33.4177 22.6963Z" fill="currentColor"></path><circle cx="24" cy="24" r="23.5" transform="rotate(-180 24 24)" stroke="currentColor"></circle></svg></a><a href="#" class="swiper-button-next w-inline-block" tabindex="0" role="button" aria-label="Next slide" aria-controls="swiper-wrapper-f613da331297fa67" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 49 48" fill="none"><path d="M35.3038 25.0108C35.6943 24.6203 35.6943 23.9871 35.3038 23.5966L28.9398 17.2326C28.5493 16.8421 27.9161 16.8421 27.5256 17.2326C27.1351 17.6232 27.1351 18.2563 27.5256 18.6469L33.1824 24.3037L27.5256 29.9606C27.1351 30.3511 27.1351 30.9843 27.5256 31.3748C27.9161 31.7653 28.5493 31.7653 28.9398 31.3748L35.3038 25.0108ZM15.1536 25.3037L34.5967 25.3037L34.5967 23.3037L15.1536 23.3037L15.1536 25.3037Z" fill="currentColor"></path><circle cx="24.5714" cy="24" r="23.5" stroke="currentColor"></circle></svg></a></div>
`);

const swiper = new Swiper(".is--home-featured-slider", {
  // Optional parameters
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: "24rem",

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    // When window width is >= 992px
    992: {
      slidesPerView: 3,
    },
  },
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});

